export enum ThemeMode {
  Light = "light",
  Dark = "dark",
  System = "system",
}

export enum ThemeDensity {
  Comfortable = "comfortable",
  Compact = "compact",
}

export enum ThemeBorder {
  Subtle = "subtle",
  Normal = "normal",
  Strong = "strong",
}

export enum ThemePreset {
  Default = "default",
  Slate = "slate",
  Blue = "blue",
  Emerald = "emerald",
  Rose = "rose",
}

export type ThemeConfig = {
  version: 1;
  mode: ThemeMode;
  preset: ThemePreset;
  primary: string;
  accent: string;
  radius: number;
  density: ThemeDensity;
  border: ThemeBorder;
};

export type ThemePresetConfig = {
  label: string;
  primary: string;
  accent: string;
};

export const THEME_PRESETS: Record<ThemePreset, ThemePresetConfig> = {
  [ThemePreset.Default]: {
    label: "Default",
    primary: "#059669",
    accent: "#f4f4f5",
  },
  [ThemePreset.Slate]: {
    label: "Slate",
    primary: "#334155",
    accent: "#e2e8f0",
  },
  [ThemePreset.Blue]: {
    label: "Blue",
    primary: "#2563eb",
    accent: "#dbeafe",
  },
  [ThemePreset.Emerald]: {
    label: "Emerald",
    primary: "#059669",
    accent: "#d1fae5",
  },
  [ThemePreset.Rose]: {
    label: "Rose",
    primary: "#e11d48",
    accent: "#ffe4e6",
  },
};
